/**
 * Sticky navigation for the prospectus
 *
 * Built from:
 * http://www.outyear.co.uk/smint/
 * https://stackoverflow.com/questions/32395988/highlight-menu-item-when-scrolling-down-to-section
 *
 * "Sticky Header"     is the programme title, enquiry and apply buttons
 * "Sticky Navigation" is the always-visible jump-to navigation menu
 *
 */

$(window).on('load', function() {
    // cache the navigation links
    var $navigationLinks = $('.sticky_menu_option');

    // cache (in reversed order) the sections
    var $sections = $($('.anchor_point').get().reverse());

    // map each section id to their corresponding navigation link
    var sectionIdTonavigationLink = {};
    $sections.each(function() {
        var id = $(this).attr('id');
        sectionIdTonavigationLink[id] = $('.sticky_menu_option[href="#' + id + '"]');
    });

    var throttle = require('./functions').throttle;

    function highlightNavigation(stickyHeaderHeight) {
        // get the current vertical position of the scroll bar
        var scrollPosition = $(window).scrollTop();

        // iterate the sections
        $sections.each(function() {
            var currentSection = $(this);
            // get the position of the section
            var sectionTop = currentSection.offset().top - ($('#sticky_nav').outerHeight());

            // if the user has scrolled over the top of the section
            if (scrollPosition >= sectionTop) {
                // get the section id
                var id = currentSection.attr('id');
                // get the corresponding navigation link
                var $navigationLink = sectionIdTonavigationLink[id];
                // if the link is not active
                if (!$navigationLink.hasClass('active')) {
                    // remove .active class from all the links
                    $navigationLinks.removeClass('active');
                    // add .active class to the current link
                    $navigationLink.addClass('active');
                }
                // we have found our section, so we return false to exit the each loop
                return false;
            }
        });
    }

    if ($('#sticky_nav').length > 0) {

        var stickyArea   = $('#sticky_nav');
        var stickyLinks  = $('#sticky_nav a');

        var stickyHeader = $('#sticky_header');
        var stickyNav    = $('#prospectus_sticky_nav');

        // initial state
        var isStuck      = false;

        // get the height of the sticky header
        var stickyHeaderCss  = $('#sticky_header').attr('style');

        $('#sticky_header').css({
            'position':   'absolute',
            'visibility': 'hidden',
            'display':    'block',
            'min-width':  '100%',
        });

        var stickyHeaderHeight  = $('#sticky_header').outerHeight();
        var stickyHeaderFromTop = stickyNav.offset().top - stickyHeaderHeight;

        // we have all required dimensions; hide the sticky header
        $('#sticky_header').attr('style', stickyHeaderCss ? stickyHeaderCss : '');

        var stickyHeight = stickyNav.outerHeight() + stickyHeaderHeight;
        var stuckHeight  = stickyHeight;

        stickyLinks.each(function(i) {

            var id = $(this).attr('href').split('#')[1];

            // add the scrolling behaviour onclick
            $(this).on('click', function(e) {
                if ($('#' + id).length > 0) {
                    var stickyTargetTop = $('#' + id).offset().top;

                    // make each section linked to focusable
                    $('#' + id).attr('tabindex', 0);

                    // stops hrefs making the page jump when clicked
                    e.preventDefault();

                    // scroll to just above the section
                    var scrollTo = stickyTargetTop - stuckHeight;

                    $('html, body').animate({
                        scrollTop: scrollTo,
                    }, 700, function() {
                        $('#' + id).focus();
                    });
                }
            });
        });

        $(window).scroll(throttle(function(){

            // determine what our visible area encompasses
            var scrollFromTop = $(window).scrollTop();

            // stick the nav once we have reached it
            if (scrollFromTop >= stickyHeaderFromTop) {
                if (!isStuck) {
                    // stick the menu
                    stickyHeader.addClass('visible');
                    stickyArea.addClass('stuck');
                    $('body').css('padding-top', stickyNav.height() + 'px');
                    isStuck = true;
                }
            } else {
                if (isStuck) {
                    // unstick the menu
                    stickyHeader.removeClass('visible');
                    stickyArea.removeClass('stuck');
                    $('body').css('padding-top', 0);
                    isStuck = false;
                }
            }

            stuckHeight = stickyHeight;

            // apply "active" class to navigation links
            highlightNavigation(stickyHeaderHeight);

        }, 16));
    }
});
